import { render, staticRenderFns } from "./LoanAdvanceForm.vue?vue&type=template&id=4a69f484"
import script from "./LoanAdvanceForm.vue?vue&type=script&lang=js"
export * from "./LoanAdvanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports